import type {
    Attachment,
    AttachmentOrFile,
    AttachmentOrFileType,
    AttachmentWithFileOrNativeFile,
    FileType,
    NativeImageType
} from "../../models/attachment";

export const isAttachment = (
    attachmentOrFile: AttachmentWithFileOrNativeFile
): attachmentOrFile is Attachment => {
    return "url" in attachmentOrFile;
};

export const isFileType = (
    attachmentOrFile: AttachmentOrFile | File | NativeImageType
): attachmentOrFile is FileType => {
    return "file" in attachmentOrFile;
};

export const isNativeImage = (
    attachmentOrFile: AttachmentOrFile | File | NativeImageType
): attachmentOrFile is NativeImageType => {
    return "uri" in attachmentOrFile;
};

export const filterAttachmentOrNativeImage = (
    attachmentOrFile: AttachmentWithFileOrNativeFile[]
): AttachmentOrFileType<never, true>[] => {
    return attachmentOrFile.filter(elem => {
        return isNativeImage(elem) || isAttachment(elem);
    });
};

export const filterAttachmentOrFileType = (
    attachmentOrFile: AttachmentWithFileOrNativeFile[]
): AttachmentOrFileType<never, false>[] => {
    return attachmentOrFile.filter(elem => {
        return isFileType(elem) || isAttachment(elem);
    });
};
